import React, { Component } from 'react';
import styled from 'styled-components';

export default class BackOnStartups extends Component {
  render() {
    return (
      <FooterSection>
        <TextWrapper>
          <Text>Líbilo se ti tento projekt?</Text> <ActionText>Prohlédni si další →</ActionText>
        </TextWrapper>
      </FooterSection>
    );
  }
}

const TextWrapper = styled.div``;

const FooterSection = styled.div`
  justify-content: center;
  display: flex;
  padding: 56px 0;
  background: white;
`;

const Text = styled.span`
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  min-width: 260px;
`;

const ActionText = styled.span`
  color: #2158ee;
  text-decoration: underline;
  font-weight: bold;
  font-size: 32px;
  cursor: pointer;
`;
